// extracted by mini-css-extract-plugin
export default {"langswitch":"langswitch__OZc8h","drop":"drop__L8Rc2","langdropdown":"langdropdown__qGjGL"};